import merge from 'lodash/merge'

import fr from '@shared/i18n/locales/fr'

export default merge(fr, {
  pt: {
    tracker: {
      _: 'Suivi',
      log: 'Connectez-vous',
      intro:
        'Bienvenue sur le tracker. Vous pouvez le visiter à tout moment en appuyant sur le bouton de suivi, et à partir de là, vous pouvez vous suivre et voir toutes les données passées que vous avez entrées.',
      columns: {
        time: 'Created at',
      },
      sign: {
        signed: 'Signed',
      },
      resultText: 'Thanks for submission!',
      resultAgain: 'Log again',
    },

    help: {
      _: 'Aidez-moi',
      title: 'Si vous avez une urgence, appelez immédiatement le 911.',
      newConversation: 'Nouvelle conversation',
      seeAllConversations: 'Voir la liste de toutes les conversations',
    },

    messages: {
      errors: {
        auth: 'Authentification échouée. Un lien est incorrect ou a expiré',
        linkExpired: 'Le lien a expiré',
        unableToJoinCall: 'Unable to join the call',
        geolocationFailed:
          "L'acquisition des informations de géolocalisation a échoué. Remplissez manuellement.",
      },

      warnings: {
        disagree:
          "Vous n'êtes pas d'accord avec les termes et conditions et ne pouvez pas poursuivre la conversation. Si vous souhaitez modifier votre décision, veuillez actualiser la page et réessayer.",
      },
    },

    labels: {
      writeReply: 'Écrire une réponse',
      noConversations: "Il n'y a pas de conversations attribuées",
      humansOnly: "Seulement avec l'homme",
      viewTracker: 'Afficher le tracker',
      tac: 'Termes et conditions',
      click: 'Où cliquez',
      here: 'ici',
      goBack: 'pour revenir en arrière',
      viewOlder: 'Afficher les conversations plus anciennes',
      pickAddress: 'Pick address',
      currentLocation: 'Current location',
      submitAddress: 'Submit Address',
      streetAddress: 'Street Address',
      zipCode: 'Zip Code',
      fillInTheForm: 'Fill in the form',
      chooseDate: 'Choose a date',
      poweredByQliqSoft: 'Powered by QliqSOFT',
    },
  },
})
